import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="87" height="55" viewBox="0 0 87 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M86.3 0L0 0L0 5.2L86.3 5.2V0Z" fill="white"/>
        <path d="M86.2999 9.40002L4.3999 9.40002L4.3999 14.6L86.2999 14.6V9.40002Z" fill="white"/>
        <path opacity="0.35" d="M86.2999 18.8L25.3999 18.8V24L86.2999 24V18.8Z" fill="white"/>
        <path opacity="0.35" d="M86.1998 28.2L41.2998 28.2V33.4L86.1998 33.4V28.2Z" fill="white"/>
        <path opacity="0.52"
              d="M46.1 50.9C46.9837 50.9 47.7 50.1837 47.7 49.3C47.7 48.4164 46.9837 47.7 46.1 47.7C45.2164 47.7 44.5 48.4164 44.5 49.3C44.5 50.1837 45.2164 50.9 46.1 50.9Z"
              fill="white"/>
        <path className="path-1"
              d="M46.1002 54.2C48.8064 54.2 51.0002 52.0062 51.0002 49.3C51.0002 46.5938 48.8064 44.4 46.1002 44.4C43.394 44.4 41.2002 46.5938 41.2002 49.3C41.2002 52.0062 43.394 54.2 46.1002 54.2Z"
              fill="white"/>
        <path opacity="0.52"
              d="M80.8998 51.5C81.7835 51.5 82.4998 50.7836 82.4998 49.9C82.4998 49.0163 81.7835 48.3 80.8998 48.3C80.0162 48.3 79.2998 49.0163 79.2998 49.9C79.2998 50.7836 80.0162 51.5 80.8998 51.5Z"
              fill="white"/>
        <path className="path-2"
              d="M80.9 54.8C83.6062 54.8 85.8 52.6062 85.8 49.9C85.8 47.1938 83.6062 45 80.9 45C78.1938 45 76 47.1938 76 49.9C76 52.6062 78.1938 54.8 80.9 54.8Z"
              fill="white"/>
        <path opacity="0.52"
              d="M63.8998 51.5C64.7835 51.5 65.4998 50.7836 65.4998 49.9C65.4998 49.0163 64.7835 48.3 63.8998 48.3C63.0162 48.3 62.2998 49.0163 62.2998 49.9C62.2998 50.7836 63.0162 51.5 63.8998 51.5Z"
              fill="white"/>
        <path className="path-3"
              d="M63.9 54.8C66.6062 54.8 68.8 52.6062 68.8 49.9C68.8 47.1938 66.6062 45 63.9 45C61.1938 45 59 47.1938 59 49.9C59 52.6062 61.1938 54.8 63.9 54.8Z"
              fill="white"/>
    </svg>
)
